module.exports = __webpack_public_path__ + "static/Muli-ExtraBoldItalic.e8d548e2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-ExtraBoldItalic.ttf
// module id = 333
// module chunks = 114276838955818